import React from 'react'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {cssTheme} from '@vio/atlas/themes'

const INDICATOR_TRANSITION_DURATION = 300
const INDICATOR_HEIGHT = 2
const HOVER_TRANSITION_DURATION = 200

const ActiveIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${INDICATOR_HEIGHT}px;
  background-color: ${cssTheme.colors.tabs.default.selected.border};
  border-radius: ${cssTheme.layout.radius.rounded};
  z-index: 1;
`

const MenuItemWrapper = styled.button`
  background: none;
  border: none;
  outline: none;
  position: relative;
  width: fit-content;
  transition: color ${HOVER_TRANSITION_DURATION}ms ease;
  padding: ${cssTheme.layout.spacing.s400} 0;
  color: ${cssTheme.colors.tabs.default.unselected.content};
  cursor: pointer;
  > div {
    opacity: 0;
  }
  &.--active {
    color: ${cssTheme.colors.tabs.default.selected.content};
    > div {
      opacity: 1;
      background-color: ${cssTheme.colors.tabs.default.selected.border};
    }
  }
  &:hover {
    > div {
      transition: all ${INDICATOR_TRANSITION_DURATION}ms
        cubic-bezier(0.4, 0, 0.2, 1);
      opacity: 1;
    }
  }
`

interface MenuItemProps {
  active: boolean
  label: string
  onClick: () => void
}

const AllFiltersCategoryItemComponent = ({
  active,
  label,
  onClick
}: MenuItemProps) => {
  return (
    <MenuItemWrapper
      tabIndex={0}
      onClick={onClick}
      className={active ? '--active' : ''}
    >
      <Text variant="labelS" align="left">
        {label}
      </Text>
      <ActiveIndicator />
    </MenuItemWrapper>
  )
}

export const AllFiltersCategoryItem = React.memo(
  AllFiltersCategoryItemComponent
)
